import "./Player.css"
import {useLocation} from "react-router-dom";
import {useClientLocale} from "../../context/client_locale";
import {useAdaptiveMobileSize} from "../../hooks/useAdaptiveMobileSize";
import {useEffect, useState} from "react";

import AudioPlayer from "../../components/audioPlayer/AudioPlayer";
import VideoPlayer from "../../components/videoPlayer/VideoPlayer";

import {ErrorMessage} from "../../components/errorMessage/ErrorMessage";

import {remoteFilePath, visitFile} from "../../services/api/File";
import {getStyleForClientRootContainer} from "../../helper/client_block_style";
import {getActualResolutionCategory, getWindowSize} from "../../utils/size";
import {getFileExtension} from "../../utils/file";
import {resolveBaseURL} from "../../services/api/API";

function getVideoType(path) {
    const extension = path?.toLowerCase().split(/[?#]/)[0].split(".").pop();

    switch (extension) {
        case "m3u8":
            return "application/x-mpegURL";
        case "webm":
            return "video/webm";
        case "mpg":
        case "mpeg":
        case "mpe":
            return "video/mpeg";
        case "mp4":
        default:
            return "video/mp4";
    }
}

function getAudioType(path) {
    const extension = path?.toLowerCase().split(/[?#]/)[0].split(".").pop();

    switch (extension) {
        case "m3u8":
            return "application/x-mpegURL";
        case "wav":
            return "audio/wav";
        case "ogg":
        case "oga":
            return "audio/ogg";
        case "mp3":
        default:
            return "audio/mpeg";
    }
}

export default function Player() {
    const adaptiveMobileSize = useAdaptiveMobileSize();
    const [isHiddenPlayer, setIsHiddenPlayer] = useState(true);
    const [isFadingListenBackground, setIsFadingListenBackground] = useState(false);
    const state = useLocation().state;
    const { strings } = useClientLocale();

    const isMobileVersion = state.isMobileVersion;
    const resolutionUnit = getActualResolutionCategory(
        isMobileVersion ? adaptiveMobileSize : getWindowSize()
    );
    let exhibition = null;
    let mediaID = null;
    let mediaType = null;
    let selectedMedia = null;
    let listenBackgroundURL = null;
    let playerBackgroundURL = null;
    const delayToSwitchBackground = 4000
    if (state) {
        mediaID = state.mediaID;
        exhibition = state.exhibition;
        selectedMedia = [...exhibition.videos, ...exhibition.audios, ...exhibition.images]
            .find(fileInfo => {
                return fileInfo.id === mediaID
            });
        mediaType = selectedMedia?.tag;
    }
    let mainContent;

    useEffect(function() {
      if (mediaID) {
        visitFile(mediaID);
      }
    }, []);

    useEffect(function() {
        setIsHiddenPlayer(true);
        setIsFadingListenBackground(false);
        const fadeTimeoutId = setTimeout(() => {
            setIsFadingListenBackground(true);
            setIsHiddenPlayer(false);
        }, delayToSwitchBackground);

        return () => {
            clearTimeout(fadeTimeoutId);
        };
    }, [playerBackgroundURL]);

    const onVideoPlayerReady = () => {

    }

    if (exhibition) {
        let listenID = exhibition.backgroundImages["Listen"];
        let playerID = exhibition.backgroundImages["Player"];
        let mediaURL = null;
        listenBackgroundURL = remoteFilePath(listenID);
        playerBackgroundURL = remoteFilePath(playerID);
        if (mediaID !== null) {
            mediaURL = remoteFilePath(mediaID);
        }
        if (selectedMedia?.path && getFileExtension(selectedMedia.path).toLowerCase() === "m3u8") {
            mediaURL = resolveBaseURL(selectedMedia?.path)
        }
        if (!isHiddenPlayer) {
            switch (mediaType) {
                case "audio":
                    mainContent = (
                        <div className={"h-full w-full flex flex-col"}>
                            <div className="basis-3/5 grow">
                            </div>
                            <div className="basis-2/5 grow">
                                <AudioPlayer
                                    resolutionUnit={resolutionUnit}
                                    src={mediaURL}
                                    type={getAudioType(selectedMedia?.path)}
                                />
                            </div>
                        </div>
                    );
                    break;
                case "video":
                    const videoJsOptions = {
                        source: mediaURL,
                        type: getVideoType(selectedMedia?.path),
                        controls: true,
                        autoplay: true,
                        width: adaptiveMobileSize.width,
                        height: adaptiveMobileSize.height,
                    };
                    mainContent = (
                        <VideoPlayer
                            options={videoJsOptions}
                            onReady={onVideoPlayerReady}
                        />
                    )
                    break;
                case "image":
                    mainContent = (
                        <div className="h-full w-full flex items-center justify-center">
                            <img
                                className="h-full w-full object-contain"
                                src={mediaURL}
                                alt={selectedMedia?.title ?? ""}
                            />
                        </div>
                    );
                    break;
                default:
                    break;
            }

        } else {
            mainContent = (
                <></>
            );
        }
    } else {
        mainContent = (
            <div className={"h-full w-full flex flex-col justify-center"}>
                <ErrorMessage>{strings["wrong_parameters"]}</ErrorMessage>
            </div>
        );
    }
    const listenStyle = getStyleForClientRootContainer(listenBackgroundURL, adaptiveMobileSize, isMobileVersion);
    const backgroundStyle = getStyleForClientRootContainer(playerBackgroundURL, adaptiveMobileSize, isMobileVersion);

    return (
        <div className="flex flex-row justify-center">
            <div
                className="player-stage bg-center bg-no-repeat"
                style={backgroundStyle}
            >
                <div
                    className={`player-listen-background bg-center bg-no-repeat ${isFadingListenBackground ? "player-listen-background-fade" : ""}`}
                    style={listenStyle}
                />
                <div className={`player-content ${isHiddenPlayer ? "" : "player-content-visible"}`}>
                    {mainContent}
                </div>
            </div>
        </div>
    );
}
